// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PaymentProfilesContext } from "@insite/content-library/Pages/SavedPaymentsPage";
import PageTitleCount from "@sc/App/Components/Common/PageTitleCount";
import React, { FC, useContext } from "react";

const SavedPaymentsTitleCount: FC<WidgetProps> = () => {
    const paymentProfilesDataView = useContext(PaymentProfilesContext);

    let totalItemCount = 0;

    if (paymentProfilesDataView.value && paymentProfilesDataView.pagination) {
        totalItemCount = paymentProfilesDataView.pagination.totalItemCount;
    }

    return <PageTitleCount countNumber={totalItemCount} countName="Card" />;
};

const widgetModule: WidgetModule = {
    component: SavedPaymentsTitleCount,
    definition: {
        group: "Saved Payments",
        displayName: "Saved Payments Title Count",
        allowedContexts: ["SavedPaymentsPage"],
    },
};

export default widgetModule;
